import { WizardErrorSteps } from '@/pages/quotation-tool/utils/constants'
import type { BuilderActions, BuilderState, StoreSlice } from '../types'

const initialBuilderState: BuilderState = {
  builderHeaderDistanceToTop: 0,
  activeStep: 0,
  stepsWithError: [WizardErrorSteps.NO_ERROR],
  sectionsErrors: {
    serviceContract: false,
    transportOption: false,
    warranty: false
  }
} as const

export const createBuilderSlice: StoreSlice<
  BuilderState & BuilderActions
> = set => ({
  // State
  ...initialBuilderState,
  // Actions
  setBuilderHeaderDistanceToTop: val =>
    set(
      { builderHeaderDistanceToTop: val },
      false,
      'setBuilderHeaderDistanceToTop'
    ),

  setActiveStep: val => set({ activeStep: val }, false, 'setActiveStep'),

  goNextStep: () =>
    set(state => ({ activeStep: state.activeStep + 1 }), false, 'goNextStep'),

  goPrevStep: () =>
    set(state => ({ activeStep: state.activeStep - 1 }), false, 'goPrevStep'),

  setStepsWithError: val => set({ stepsWithError: val }),

  resetBuilder: () => set(initialBuilderState),

  setSectionsErrors: val =>
    set(state => ({
      sectionsErrors: {
        ...state.sectionsErrors,
        ...val
      }
    }))
})
